import http from '@/utils/http'
import {
  PhysicalWarehouseListGetResult,
  WarehouseModel,
  PrintLabelListGetResult,
  I18nListGetResult,
  RegionWarehouseListGetResult,
} from './model'
import { BasicList } from '../model/baseModel'

enum Source {
  WAREHOUSE_LIST = '/base/web/warehouse/region/all/list',
  PHYSICAL_WAREHOUSE = '/base/web/warehouse/region/all/physics',
  ALL_PHYSICAL_WAREHOUSE = '/base/web/warehouse/region/all/physicslist',
  ALL_REGION_WAREHOUSE = '/base/web/warehouse/region/all/list',
  LOG = '/owms/common/client_log',
  WAREHOUSE_DETAIL = '/base/web/warehouse/region/detail',
  PHYSICAL_WAREHOUSE_CHANGE = '/warehouse/switch',
  PRINT_LABEL_LIST = '/base/web/print/print-label/list',
  PRINT_PERMISSION_LIST = '/base/web/print/param-config/list/permission',
  I18N_LIST = '/base/web/language/all/label/list',
  PRINT_LIST_API = '/base/web/print/settings/page/list',
  PRINT_CHANNEL_LIST_API = '/base/web/service-channel/available/list',
  REGION_WAREHOUSE = '/base/login/region-warehouse',
  // 语言(语种)列表查询
  LANGUAGE_LIST = '/base/web/language/list',
}

export * from './model'

// 服务提供商列表
export const getWarehouseList = () => {
  return http.post<BasicList<WarehouseModel>>({ url: Source.WAREHOUSE_LIST })
}
// 物理仓列表
export const getPhysicalWarehouseList = (data: { regionWarehouseCode: string }) => {
  return http.post<PhysicalWarehouseListGetResult>({
    url: Source.PHYSICAL_WAREHOUSE,
    data: {
      ...data,
      // status: 1,
      proStatus: 2,
    },
  })
}

/**
 * 获取当前区域仓下所有物理仓信息
 * @param data
 * @returns
 */
export const getAllPhysicalWarehouseList = (data: { regionWarehouseCode: string }) => {
  return http.post<PhysicalWarehouseListGetResult>({
    url: Source.ALL_PHYSICAL_WAREHOUSE,
    data,
  })
}

/**
 * 获取所有区域仓信息
 * @param data
 * @returns
 */
export const getAllRegionWarehouseList = (data: { regionWarehouseCode: string }) => {
  return http.post<RegionWarehouseListGetResult>({
    url: Source.ALL_REGION_WAREHOUSE,
    data,
  })
}

// 前端日志
export const reportException = (data: Recordable) => {
  return http.post({ url: Source.LOG, data })
}

/**
 * 获取区域仓详情
 * @param data
 * @returns
 */
export const getWarehouseDetail = (data: { regionWarehouseCode: string }) => {
  return http.post<WarehouseModel>({ url: Source.WAREHOUSE_DETAIL, data })
}

/**
 * 切换物理仓
 * @param data
 */
export const changePhysicalWarehouseApi = async (data: { warehouseCode: string }) => {
  return http.post<void>({
    url: Source.PHYSICAL_WAREHOUSE_CHANGE + `?warehouseCode=${data.warehouseCode}`,
  })
}

/**
 * 根据菜单id获取页面设置的打印标签
 * @param data
 * @returns
 */
export const getPrintLabelList = (data: { labelName?: string; permissionId: number }) =>
  http.post<PrintLabelListGetResult>({ url: Source.PRINT_LABEL_LIST, data })

/**
 * 查询所有打印菜单信息
 * @returns
 */
export const getPrintPermissionList = () =>
  http.post<{ records: { id: string; permissionNameCn: string; permissionNameEn: string }[] }>({
    url: Source.PRINT_PERMISSION_LIST,
  })

/**
 * 查询I18N翻译列表
 * @returns
 */
export const getI18nList = () =>
  http.post<I18nListGetResult>({
    url: Source.I18N_LIST,
  })

/**
 * 获取打印机设置列表
 */
export const getPronterSettingListAPI = (data: { labelName?: string; permissionId: number }) =>
  http.post({
    url: Source.PRINT_LIST_API,
    data,
  })

/**
 * 获取打印机设置渠道列表
 */
export const getPronterSettingChannelListAPI = (data: {
  labelName?: string
  permissionId: number
}) =>
  http.post({
    url: Source.PRINT_CHANNEL_LIST_API,
    data,
  })

// 获取登录仓库信息
export const regionWarehouse = () =>
  http.post<{ records: WarehouseModel[] }>({
    url: Source.REGION_WAREHOUSE,
  })

// 语言(语种)列表查询
export const getLanguageList = () =>
  http.post<{ records: { currentLanguage: string; langCode: string }[] }>({
    url: Source.LANGUAGE_LIST,
  })

/** 获取当前语言的标签 */
export const getLanguageListApi = () => {
  return http.post<{
    records: {
      codeStr: string //	标签（标签名称）/编码，注意: 编码值范围 - (1810101000~1810109999))	string
      codeValue: string //	标签翻译/编码值描述	string
      langCode?: string //	语言国际代码	string
    }[]
  }>({
    url: '/base/pda/language/all/label/list',
  })
}

/**
 * 收集保存标签
 * @returns
 */
export function labelCollectSave(req: {
  labelCodeList?: string[] //	多语言标签		true	array string
  langCode?: string //	语种		true	string
}) {
  return http.post<null>({
    url: '/base/label-collect/save',
    data: req,
  })
}
